/**
 * DOM-Layout für den Flotten-Tab: Hologramm-Container, Name, Klasse, Produktion, Stats.
 */
import { SHIP_TYPE_DEFS, SHIP_CLASS_NAMES } from '../config/ShipTypes';
import { createFleetShipSwipeArea } from './FleetShipSwipeArea';
import { isMobile } from './UITheme';

export interface FleetTabLayoutResult {
  nameEl: HTMLDivElement;
  classEl: HTMLDivElement;
  prodEl: HTMLDivElement;
  statsEl: HTMLDivElement;
  canvas: HTMLCanvasElement;
  fleetContainer: HTMLDivElement;
}

export function createFleetTabLayout(
  container: HTMLElement,
  getSelectedType: () => number,
  onSelect: (type: number) => void | Promise<void>,
): FleetTabLayoutResult {
  const m = isMobile();

  // Force the container into a known layout state for absolute children.
  container.style.position = 'relative';
  container.style.overflow = 'hidden';

  const layout = document.createElement('div');
  layout.style.cssText =
    'position:absolute;inset:0;display:flex;flex-direction:column;overflow:hidden;';

  const fleetContainer = document.createElement('div');
  fleetContainer.style.cssText =
    'position:relative;flex:1;min-height:0;overflow:hidden;' +
    '--fleet-pad:clamp(0.75rem,2vh,1.25rem);';

  const { wrap: canvasWrap, canvas } = createFleetShipSwipeArea(
    getSelectedType,
    onSelect,
  );
  Object.assign(canvasWrap.style, {
    position: 'absolute', inset: '0', zIndex: '0',
  });
  fleetContainer.appendChild(canvasWrap);

  const overlay = document.createElement('div');
  overlay.style.cssText =
    'position:absolute;inset:0;z-index:1;pointer-events:none;';

  const nameEl = document.createElement('div');
  nameEl.style.cssText =
    'position:absolute;top:var(--fleet-pad);left:50%;transform:translateX(-50%);' +
    'font-size:clamp(1.4rem,5vw,1.9rem);font-weight:700;letter-spacing:0.15em;' +
    'text-transform:uppercase;white-space:nowrap;color:#fff;' +
    'text-shadow:0 0 24px rgba(136,204,255,0.8),0 0 48px rgba(100,180,255,0.4),0 2px 6px rgba(0,0,0,0.9);';
  nameEl.textContent = SHIP_TYPE_DEFS[getSelectedType()].name;
  overlay.appendChild(nameEl);

  const classEl = document.createElement('div');
  classEl.style.cssText =
    'position:absolute;top:var(--fleet-pad);right:var(--fleet-pad);' +
    'padding:4px 10px;border-radius:4px;' +
    'background:rgba(253,221,0,0.15);border:1px solid rgba(253,221,0,0.5);' +
    'font-size:clamp(0.7rem,2.2vw,0.85rem);font-weight:700;letter-spacing:0.12em;' +
    'text-transform:uppercase;color:#fd0;' +
    'text-shadow:0 0 10px rgba(253,221,0,0.5);' +
    'box-shadow:0 0 12px rgba(253,221,0,0.2);';
  classEl.innerHTML = `<span style="opacity:0.8;font-size:0.85em;">Klasse</span> ${SHIP_CLASS_NAMES[SHIP_TYPE_DEFS[getSelectedType()].shipClass]}`;
  overlay.appendChild(classEl);

  const prodEl = document.createElement('div');
  prodEl.style.cssText =
    'position:absolute;bottom:var(--fleet-pad);left:var(--fleet-pad);' +
    'pointer-events:auto;' +
    (m ? 'max-width:40%;' : '');
  overlay.appendChild(prodEl);

  const statsEl = document.createElement('div');
  statsEl.style.cssText =
    'position:absolute;bottom:var(--fleet-pad);right:var(--fleet-pad);' +
    'pointer-events:auto;' +
    (m ? 'max-width:42%;max-height:65%;overflow-y:auto;' : '');
  overlay.appendChild(statsEl);

  fleetContainer.appendChild(overlay);
  layout.appendChild(fleetContainer);
  container.appendChild(layout);

  return { nameEl, classEl, prodEl, statsEl, canvas, fleetContainer };
}
